import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipModule } from '../../components';
import { InputComponent } from './input.component';
import { InputTypeDirective } from './input-type.directive';

@NgModule({
  declarations: [
    InputComponent,
    InputTypeDirective
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule
  ],
  providers: [],
  exports: [
    InputComponent,
    InputTypeDirective
  ]
})
export class InputModule {
}
